import { useState } from 'react'
import useFetch from '../hooks/useFetch'
import useSnackbar from '../hooks/useSnackbar'
import { apiWrapper } from './dataHookUtils'

export default () => {
  const fetch = useFetch()
  const { newMessage } = useSnackbar()

  const [isLoading, setIsLoading] = useState(false)
  const [jobs, setJobs] = useState([])
  const [jobHistory, setJobHistory] = useState([])

  const getOptions = { method: 'GET' }
  const postHeaders = { "Content-Type": "application/json" }

  const postOptions = (data) => ({
    method: 'POST',
    headers: postHeaders,
    body: JSON.stringify(data)
  })

  const fetchAwsJobs = async () => {
    try {
      setIsLoading(true)
      const data = await apiWrapper({
        fetch,
        url: `awsJobs`,
        options: getOptions
      });
      setJobs(data)
      return data
    } catch (e) {
      newMessage({ message: e?.message || 'Error getting AWS jobs', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchCreateAwsJob = async (job) => {
    try {
      setIsLoading(true)
      return await apiWrapper({
        fetch,
        url: `awsJobs/create`,
        options: postOptions(job)
      });
    } catch (e) {
      newMessage({ message: e?.message || 'Error creating AWS job', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchUpdateAwsJob = async (id, job) => {
    try {
      setIsLoading(true)
      return await apiWrapper({
        fetch,
        url: `awsJobs/${encodeURIComponent(id)}/update`,
        options: postOptions(job)
      });
    } catch (e) {
      newMessage({ message: e?.message || 'Error updating AWS job', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchToggleAwsJob = async (id, enabled) => {
    try {
      setIsLoading(true)
      return await apiWrapper({
        fetch,
        url: `awsJobs/${encodeURIComponent(id)}/toggle`,
        options: postOptions({ enabled })
      });
    } catch (e) {
      newMessage({ message: e?.message || 'Error updating AWS job status', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchDeleteAwsJob = async (id) => {
    try {
      setIsLoading(true)
      return await apiWrapper({
        fetch,
        url: `awsJobs/${encodeURIComponent(id)}/delete`,
        options: postOptions({})
      });
    } catch (e) {
      newMessage({ message: e?.message || 'Error deleting AWS job', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchRunAwsJob = async (id) => {
    try {
      setIsLoading(true)
      return await apiWrapper({
        fetch,
        url: `awsJobs/${encodeURIComponent(id)}/run`,
        options: postOptions({})
      });
    } catch (e) {
      newMessage({ message: e?.message || 'Error running AWS job', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const fetchAwsJobHistory = async (id) => {
    try {
      setIsLoading(true)
      const data = await apiWrapper({
        fetch,
        url: `awsJobs/${encodeURIComponent(id)}/history`,
        options: getOptions
      });
      setJobHistory(data)
      return data
    } catch (e) {
      newMessage({ message: e?.message || 'Error getting AWS job history', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    jobs,
    jobHistory,
    fetchAwsJobs,
    fetchCreateAwsJob,
    fetchUpdateAwsJob,
    fetchToggleAwsJob,
    fetchDeleteAwsJob,
    fetchRunAwsJob,
    fetchAwsJobHistory
  }
}
